﻿import subscribeForm from './modules/subscribe/subscribe-form';
import ClickNavigationEvent from './modules/datalayer/events/click-navigation-event';
import DataLayerNavigation from "./modules/datalayer/classes/datalayer-navigation";

(function () {
    const params = new URLSearchParams(window.location.search);
    ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (key) {
        const value = params.get(key);
        if (value) {
            sessionStorage.setItem(key, value);
        }
    });
})();

document.addEventListener('DOMContentLoaded', function () {
    ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (key) {
        const field = document.getElementById(key);
        if (field) {
            field.value = sessionStorage.getItem(key) || '';
        }
    });
});

if (subscribeForm.canInit('#subscribe-form')) {
    subscribeForm.init('#subscribe-form');
}

document.querySelectorAll('[trackable-link]')
    .forEach(item => item.addEventListener('click', trackableLinkHandler));

function trackableLinkHandler(event) {
    const link = event.currentTarget;
    const item = link.innerText.trim();
    const menu = link.closest('[trackable-menu]')?.getAttribute('trackable-menu') ?? 'unknown';
    const parent = link.closest('[trackable-group]')?.getAttribute('trackable-group').trim();
    const navigation = new DataLayerNavigation(menu, buildNavBreadcrumb(parent, item), item, link.getAttribute('href'));
    const clickNavigationEvent = new ClickNavigationEvent(navigation);
    clickNavigationEvent.push();
}

function buildNavBreadcrumb(parent, item) {
    if (parent && parent !== item) {
        return `${parent} > ${item}`;
    }
    
    return item;
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.nav-dropdown').forEach(function (dropdown) {
        const menu = dropdown.querySelector('.nav-dropdown-menu');
        if (!menu) return;

        let closeTimer;

        function open() {
            clearTimeout(closeTimer);
            menu.style.display = 'block';
        }

        function scheduleClose() {
            closeTimer = setTimeout(function () {
                if (!dropdown.matches(':hover') && !menu.matches(':hover')) {
                    menu.style.display = 'none';
                }
            }, 100);
        }

        dropdown.addEventListener('mouseenter', open);
        dropdown.addEventListener('mouseleave', scheduleClose);
        menu.addEventListener('mouseenter', open);
        menu.addEventListener('mouseleave', scheduleClose);
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.getElementById('siteSearch');
    const resultsBox = document.getElementById('searchResults');
    if (!searchInput || !resultsBox) return;

    let debounceTimer;

    searchInput.addEventListener('input', function () {
        const query = searchInput.value.trim();

        clearTimeout(debounceTimer);

        if (query.length < 2) {
            resultsBox.innerHTML = '';
            resultsBox.style.display = 'none';
            return;
        }

        // wait 300ms after the user stops typing before searching
        debounceTimer = setTimeout(function () {
            fetch('/umbraco/surface/search/search?query=' + encodeURIComponent(query))
                .then(response => response.json())
                .then(results => {
                    if (results.length === 0) {
                        resultsBox.innerHTML = '<div class="search-no-results">No results found</div>';
                    } else {
                        resultsBox.innerHTML = results
                            .map(r => `<a href="${r.url}" class="search-result-item">${r.title}</a>`)
                            .join('');
                    }
                    resultsBox.style.display = 'block';
                })
                .catch(() => {
                    resultsBox.innerHTML = '';
                    resultsBox.style.display = 'none';
                });
        }, 300);
    });

    // close the dropdown when clicking outside
    document.addEventListener('click', function (e) {
        if (!searchInput.contains(e.target) && !resultsBox.contains(e.target)) {
            resultsBox.style.display = 'none';
        }
    });

    const navBar = document.querySelector('.nav-bar');

    navBar.addEventListener('mouseleave', function () {
        resultsBox.style.display = 'none';
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.getElementById('siteSearchMobile');
    const resultsBox = document.getElementById('searchResultsMobile');
    if (!searchInput || !resultsBox) return;

    let debounceTimer;

    searchInput.addEventListener('input', function () {
        const query = searchInput.value.trim();

        clearTimeout(debounceTimer);

        if (query.length < 2) {
            resultsBox.innerHTML = '';
            resultsBox.style.display = 'none';
            return;
        }

        // wait 300ms after the user stops typing before searching
        debounceTimer = setTimeout(function () {
            fetch('/umbraco/surface/search/search?query=' + encodeURIComponent(query))
                .then(response => response.json())
                .then(results => {
                    if (results.length === 0) {
                        resultsBox.innerHTML = '<div class="search-no-results">No results found</div>';
                    } else {
                        resultsBox.innerHTML = results
                            .map(r => `<a href="${r.url}" class="search-result-item">${r.title}</a>`)
                            .join('');
                    }
                    resultsBox.style.display = 'block';
                })
                .catch(() => {
                    resultsBox.innerHTML = '';
                    resultsBox.style.display = 'none';
                });
        }, 300);
    });

    // close the dropdown when clicking outside
    document.addEventListener('click', function (e) {
        if (!searchInput.contains(e.target) && !resultsBox.contains(e.target)) {
            resultsBox.style.display = 'none';
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const sentinel = document.getElementById("nav-sentinel");
    const navBar = document.querySelector(".nav-bar");
    const scrollHeader = document.querySelector('.scroll-header');
    if (!sentinel || !navBar) return;

    const observer = new IntersectionObserver(
        ([entry]) => {
            const isStuck = !entry.isIntersecting;
            // sentinel out of view => nav-bar is stuck to the top
            navBar.classList.toggle("stuck", isStuck);
            if (scrollHeader) {
                scrollHeader.classList.toggle("visible", isStuck);
            }
        },
        { threshold: 0 }
    );
    observer.observe(sentinel);
});

document.addEventListener('DOMContentLoaded', function () {
    const params = new URLSearchParams(window.location.search);
    const scrollTarget = params.get('product');   // e.g. ?scrollTo=finance

    if (scrollTarget) {
        const element = document.getElementById(`product-${scrollTarget}`);
        if (element) {
            setTimeout(function () {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 1000); 
        }
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const menu = document.querySelector('.mobile-menu');
    if (!menu) return;

    // drill into a submenu
    menu.querySelectorAll('.menu-item[data-target]').forEach(function (item) {
        item.addEventListener('click', function () {
            const sub = document.getElementById(item.dataset.target);
            if (sub) {
                sub.classList.add('active');
                menu.classList.add('submenu-open');
            }
        });
    });

    // back to main
    menu.querySelectorAll('.menu-back').forEach(function (backBtn) {
        backBtn.addEventListener('click', function () {
            backBtn.closest('.menu-sub').classList.remove('active');
            menu.classList.remove('submenu-open');
        });
    });

    // reset to main panel when the offcanvas closes
    const offcanvas = document.getElementById('offcanvasExample');
    if (offcanvas) {
        offcanvas.addEventListener('hidden.bs.offcanvas', function () {
            menu.classList.remove('submenu-open');
            menu.querySelectorAll('.menu-sub.active').forEach(s => s.classList.remove('active'));
        });
    }
});